<template>
  <z-form-group class="row">
    <div class="col-3 text-right">
      {{ $t('mailer.mailing.form.field.macros.title') }}
    </div>
    <div class="form-input col-9">
      <template v-for="(title, key) in $t('db.recipient.tags')">
        <i-button
          :key="key"
          class="button-tag"
          type="default"
          icon="md-add"
          @click="set_macros(key)"
        >
          {{ title }}</i-button
        >
      </template>
    </div>
  </z-form-group>
</template>

<script>
  export default {
    methods: {
      set_macros(val) {
        this.$emit('input', val);
      }
    }
  };
</script>

<style lang="scss">
  .button-tag {
    padding: 0 6px;
    margin: 3px;
    height: 22px;
    font-size: 12px;

    span {
      margin-left: 0px;
    }
  }
</style>